import React, { FC, useCallback } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useAppStore } from 'stores/appStore';
import { useNameSuggestions } from 'hooks/useNameSuggestions';
import { Button, SkeletonGroup, SkeletonRectangle, Text, TextButton } from '@wix/design-system';
import styles from '../SelectNameStep.scss';
import { SparklesSmall, RefreshSmall } from '@wix/wix-ui-icons-common';

export const SelectNameStepSuggestions: FC = () => {
  const { t } = useTranslation();
  const { suggestions, isLoading, refetch } = useNameSuggestions();

  const setStoreName = useAppStore((state) => state.setStoreName);

  const renderOptions = useCallback(() => {
    if (isLoading) {
      return (
        <SkeletonGroup>
          <div className={styles.selectNameStepSuggestionsOptions}>
            {[...Array.from({ length: 5 })].map((_, index) => (
              <SkeletonRectangle key={index} width="100px" height="32px" />
            ))}
          </div>
        </SkeletonGroup>
      );
    }

    return (
      <div className={styles.selectNameStepSuggestionsOptions}>
        {suggestions?.map((name) => (
          <Button
            onClick={() => setStoreName(name)}
            prefixIcon={<SparklesSmall />}
            priority="secondary"
            size="small"
            skin="dark"
            key={name}
          >
            {name}
          </Button>
        ))}
      </div>
    );
  }, [suggestions, isLoading, setStoreName]);

  return (
    <div className={styles.selectNameStepSuggestions}>
      <div className={styles.selectNameStepSuggestionsHeader}>
        <Text>{t('select-name-step.suggestions.title')}</Text>
        <TextButton disabled={isLoading} onClick={() => refetch()} prefixIcon={<RefreshSmall />} size="small">
          {t('select-name-step.suggestions.regenerate')}
        </TextButton>
      </div>
      {renderOptions()}
    </div>
  );
};
